import { Fragment } from 'react'
import styles from './EditModal.module.scss'
import { getVisitorFeedbackLabel } from '../utils'
import { getSanitisedHtmlObj } from 'Utils/html'

const ReadOnlyInfo = (props) => {
  const {
    data: {
      question_asked_by_visitor,
      response_shown_to_visitor,
      visitor_feedback,
      content_used_for_generating_response
    }
  } = props

  const { title = '', content_type = '' } = content_used_for_generating_response ?? {}

  const sanitisedResponseShownToVisitorObj = getSanitisedHtmlObj(response_shown_to_visitor)

  return (
    <Fragment>
      <div className={styles.RowItem}>
        <h4>Visitor Question:</h4>
        <div className={styles.QuestionByVisitor}>{question_asked_by_visitor}</div>
      </div>

      <div className={styles.RowItem}>
        <h4>Response Shown:</h4>
        <div className={styles.ResponseShownByBot} dangerouslySetInnerHTML={sanitisedResponseShownToVisitorObj} />
      </div>

      <div className={styles.RowItem}>
        <h4>Visitor Feedback: </h4>
        <div>{getVisitorFeedbackLabel(visitor_feedback)}</div>
      </div>

      <div className={styles.RowItem}>
        <h4>Content used for the response: </h4>
        <div>{title}</div>
      </div>

      <div className={styles.RowItem}>
        <h4>Content type: </h4>
        <div className={styles.Capitalize}>{content_type}</div>
      </div>
    </Fragment>
  )
}

export default ReadOnlyInfo
